import { useMemo } from "react";
import {
  BarChartIcon,
  BoxModelIcon,
  CalendarIcon,
  DimensionsIcon,
  LayersIcon,
} from "@radix-ui/react-icons";
import { useParams } from "react-router-dom";
import { NavigationItems, NavigationItemId } from "@/shared/types/navigation";

const navigationItems = (storeKey: string) => [
  {
    id: NavigationItems.LOD.id,
    label: NavigationItems.LOD.name,
    icon: LayersIcon,
    to: `/stores/${storeKey}`,
  },
  {
    id: NavigationItems.LOD_ASSIGNMENT.id,
    label: NavigationItems.LOD_ASSIGNMENT.name,
    icon: CalendarIcon,
    to: `/stores/${storeKey}/assignment`,
  },
  {
    id: NavigationItems.LAD.id,
    label: NavigationItems.LAD.name,
    icon: BarChartIcon,
    to: `/stores/${storeKey}/dashboard`,
  },
  {
    id: NavigationItems.GCG.id,
    label: NavigationItems.GCG.name,
    icon: DimensionsIcon,
    to: `/stores/${storeKey}/gondola-change-groups`,
  },
  {
    id: NavigationItems.SSCC.id,
    label: NavigationItems.SSCC.name,
    icon: BoxModelIcon,
    to: `/stores/${storeKey}/sscc`,
  },
];

export const useHeaderNavigationLinks = ({
  exclude = [],
}: {
  exclude?: NavigationItemId[];
}) => {
  const { storeKey = "" } = useParams();

  const availableLinks = useMemo(() => {
    return navigationItems(storeKey).filter(
      (item) => !exclude.includes(item.id)
    );
  }, [storeKey, exclude]);

  return availableLinks;
};
